import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeContext } from 'styled-components';
import { AuthContext } from '../../auth/providers/AuthProvider';

const BillMiniDashboard = ({ bill }) => {
    const theme = useContext(ThemeContext);
    const { authClaims } = useContext(AuthContext);

    // Calculate current balance from participant data
    const currentBalance = React.useMemo(() => {
        if (!bill || !authClaims?.user_sub) {
            return 0;
        }
        
        // Check if user is the owner
        const isOwner = bill.owner_sub && 
                       bill.owner_sub.toUpperCase() === authClaims.user_sub.toUpperCase();
        
        if (isOwner) {
            // If owner, sum all participants' balances (what others owe to the owner)
            // Use absolute value to show total owed
            const totalOwed = (bill.participants || []).reduce((sum, participant) => {
                return sum + Math.abs(participant.balance || 0);
            }, 0);
            return totalOwed;
        }
        
        // If not owner, find the current user's participant record
        const userParticipant = bill.participants?.find(
            p => p.user_sub && p.user_sub.toUpperCase() === authClaims.user_sub.toUpperCase()
        );
        
        return Math.abs(userParticipant?.balance || 0);
    }, [bill, authClaims]);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(Math.abs(amount));
    };

    if (!theme) {
        return null;
    }

    return (
        <Box
            sx={{
                padding: '8px 16px',
                backgroundColor: theme?.colors?.brandSecondary || 'rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                marginTop: '4px',
                minHeight: '40px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                border: `1px solid ${theme?.colors?.brandPrimary || '#212447'}`,
                boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.2)',
            }}
        >
            <Typography
                sx={{
                    color: theme?.colors?.text || '#fff',
                    fontSize: '11px',
                    opacity: 0.7,
                    marginBottom: '2px',
                }}
            >
                Current Balance
            </Typography>
            <Typography
                sx={{
                    color: theme?.colors?.text || '#fff',
                    fontSize: '16px',
                    fontWeight: 700,
                }}
            >
                {formatCurrency(currentBalance)}
            </Typography>
        </Box>
    );
};

export default BillMiniDashboard;
